import { useEffect, useRef } from 'react';

const useFilterSidebar = (filter_open, set_filter_open) => {
  const sidebar_ref = useRef(null);

  useEffect(() => {
    if (filter_open) {
      const click_handle = (e) => {
        if (!sidebar_ref.current.contains(e.target)) {
          set_filter_open(false);
        }
      };
      window.addEventListener('click', click_handle);
      return () => {
        window.removeEventListener('click', click_handle);
      };
    }
    return () => {};
    // eslint-disable-next-line
  }, [filter_open]);

  useEffect(() => {}, []);

  return [sidebar_ref];
};

export default useFilterSidebar;
